export class ResendPasswordsDto {
  constructor(data) {
    /** @type {number[]} */
    this.user_ids = data.user_ids;
  }
}
